import React from "react";
import { Layout, Col, Row, Card, BackTop, Tabs, Typography } from "antd";
import {
  ShopTwoTone,
  WalletTwoTone,
  HomeTwoTone,
  SmileTwoTone,
} from "@ant-design/icons";
import "../assets/css/account.css";
import PastOrders from "../components/PastOrders";
import WalletPaymentMethod from "../components/Account/WalletPaymentMethods";
import Address from "../components/Account/Address";
import GetTabTitle from "../components/Account/GetTabTitle";
import UseWindowSize from "../hooks/UseWindowSize";

const { TabPane } = Tabs;
const { Title } = Typography;

const panelList = [
  {
    key: "1",
    title: "Orders",
    text: "",
    icon: <ShopTwoTone />,
    contentHeaderText: "Past Orders History",
    component: <PastOrders />,
  },
  {
    key: "2",
    title: "Payment",
    text: "",
    icon: <WalletTwoTone />,
    contentHeaderText: "Payments",
    component: <WalletPaymentMethod />,
  },
  {
    key: "3",
    title: "Addresses",
    text: "",
    icon: <HomeTwoTone />,
    contentHeaderText: "Manage your Addresses",
    component: <Address />,
  },
];

const AccountPage: React.FC = (props: any) => {
  const { Content } = Layout;

  const { width } = UseWindowSize();
  const mode = width > 900 ? "left" : "top";
  return (
    <div>
      <Layout>
        <Content className="site-layout">
          <Row>
            <Col span={24}>
              <Card
                title={
                  <Typography.Title level={2}>
                    <SmileTwoTone />
                    &nbsp; Hello John
                  </Typography.Title>
                }
                className="account-card-container"
              >
                <Tabs type="card" defaultActiveKey="1" tabPosition={mode}>
                  {panelList.map((item, i) => (
                    <TabPane tab={<GetTabTitle item={item} />} key={item.key}>
                      <Title level={4}>{item.contentHeaderText}</Title>
                      {item.component}
                    </TabPane>
                  ))}
                </Tabs>
              </Card>
            </Col>
          </Row>
          <BackTop />
        </Content>
      </Layout>
    </div>
  );
};

export default AccountPage;
